import {
  // saveTotals,
  // saveDescriptionOfMerchandiseField,
  saveDescriptionOfMerchandiseLineItem,
  saveDutyFromHts,
  saveDutyAndFeeFromHts,
  saveDescriptionOfMerchandiseDutyItemArray
} from '../api/setFormData'
import React, { Component } from 'react'
import { pgaFlagTypeList } from '../formSections/pga/constantsPGA'
import isEqual from 'lodash/isEqual'
import get from 'lodash/get'
import intersection from 'lodash/intersection' 
import { confirmAlert } from "react-confirm-alert";
import { isStcFlow } from '../util/index';
import { isShipmentFromEngine } from '../../util/index';
import { shouldSkipItDateItNumberValidation } from '../util/constants';
import {
  isCpscCp2Tariff,
  shouldSkipIncompleteCpscFlag,
} from '../formSections/pga/CPSC_CPS/util'

const IT_NUMBER_REGEX = /^[a-z0-9]+$/i;
// When DISCLAIM_PGA is selected, all FDA sub-types are automatically included
const fdaDisclaimList = ["FDA_BIO","FDA_COS","FDA_DEV","FDA_DRU","FDA_FOO","FDA_RAD","FDA_TOB","FDA_VME"];

export const isWarehouseEntry = entryTypeInfo =>{
  return entryTypeInfo?.entryType=="31"
}

//copied to sumTotalCharges
export const sumGrossWeight = invoiceItems => {
  let grossWeight = 0
  var lineItemWeight
  let totalLineItems = []
  invoiceItems.forEach(invoiceItem => {
    invoiceItem.merchandiseLineItems.forEach(lineItem => {
      totalLineItems.push(lineItem)
    })
  })
  totalLineItems.forEach(lineItem => {
    if(lineItem.articleHeader != "V"){ // Exclude virtual items
   if (lineItem.grossWeight.weightUnits === 'LB') {
      lineItemWeight = (parseFloat(lineItem.grossWeight.weight) * 0.453592).toFixed(2) // LB to KG conversion
    } else lineItemWeight = lineItem.grossWeight.weight
    grossWeight = grossWeight + parseFloat(lineItemWeight)
    }
  })
  return parseFloat(grossWeight).toFixed(2)
}
const  deepCompareWithDepth = (obj1, obj2, depth) => {
  if(obj1 === obj2)return true;
  if (depth === 0) {
    return true;
  }
  if(typeof obj1 == "function" || typeof obj2 == "function"){
    return (typeof obj1) == (typeof obj2)
  }
  if (typeof obj1 !== 'object' || typeof obj2 !== 'object' || !obj1 || !obj2) {
    return obj1 === obj2;
  }

  const isArray1 = Array.isArray(obj1);
  const isArray2 = Array.isArray(obj2);

  if (isArray1 !== isArray2) {
    return false;
  }


  if (isArray1) {
    if (obj1.length !== obj2.length) {
      return false;
    }
    if(!obj1.length)return true;

    for (let i = 0; i < obj1.length; i++) {
      if (!deepCompareWithDepth(obj1[i], obj2[i], depth - 1)) {
        
        return false;
      }
    }

    return true;
  }

  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);
  if (keys1.length !== keys2.length) {
    return false;
  }
  // Ignore React internal properties for comparison
  for (const key of keys1.filter(aaaa=>!["type","elementType","_debugOwner","_owner","_self","_source","_iterator"].includes(aaaa)) ) {
    if (!deepCompareWithDepth(obj1[key], obj2[key], depth - 1)) {
      return false;
    }
  }

  return true;
}

export const ch82SetHtses = ["8205906000", "8206000000", "8211100000", "8215100000", "8215200000"];

export const propsAreEqual_NoRerenderNeeded = (prop1,prop2) => {
  const theyAreEqual = deepCompareWithDepth(prop1,prop2,50);
  return theyAreEqual;
}

const MERCH_LINE_FORM_VALUE_KEYS = [
  'newValue',
  'fieldName',
  'setINPUTID',
  'penClicked',
  'rbCounterID',
];

export function getActiveFormInputId(props) {
  // fieldName is the rubber-bind / focused DOM id (id + shipmentId).
  // setINPUTID is the setter function from MainForm — never use it as the id.
  const raw = props?.fieldName;
  return typeof raw === 'string' ? raw : '';
}

export function formValuesTargetThisMerchandiseLine(prevProps, nextProps) {
  const merchandiseId = nextProps.merchandiseId ?? prevProps.merchandiseId;
  const lineItemIndex = nextProps.lineItemIndex ?? prevProps.lineItemIndex;
  const invoiceItemIndex = nextProps.invoiceItemIndex ?? prevProps.invoiceItemIndex;
  if (merchandiseId == null && lineItemIndex == null) return false;

  const activeInputId = getActiveFormInputId(nextProps);
  if (!activeInputId) return false;

  const merchandiseIdStr = merchandiseId != null ? String(merchandiseId) : '';
  if (merchandiseIdStr && activeInputId.includes(merchandiseIdStr)) return true;

  // Line fields: `${lineItemIndex}commercialDescription` (+ shipmentId)
  if (lineItemIndex != null && activeInputId.startsWith(String(lineItemIndex))) {
    return true;
  }

  // Duty fields: `${invoiceItemIndex}-${lineItemIndex}-${index}-htsus`
  if (
    lineItemIndex != null &&
    invoiceItemIndex != null &&
    activeInputId.startsWith(`${invoiceItemIndex}-${lineItemIndex}-`)
  ) {
    return true;
  }
  if (lineItemIndex != null && activeInputId.includes(`-${lineItemIndex}-`)) {
    return true;
  }

  return false;
}

const INVOICE_LINE_SCALAR_PROPS = [
  'invoiceNumber',
  'invoiceDate',
  'poNumber',
  'currency',
  'frieghtCharges',
  'frieghtInsurance',
  'otherDeductions',
  'otherAdditions',
  'totalEnteredValue',
  'totalCharges',
  'invoiceAmount',
  'incoterm1',
  'totalAdditions',
  'totalDeletions',
  'calculatedAdditions',
  'calculatedDeletions',
];

const INVOICE_LINE_FORM_VALUE_KEYS = [
  'newValue',
  'fieldName',
  'setINPUTID',
  'penClicked',
  'shipmentId',
  'rbCounterID',
  'formDisabled',
];

function formValuesTargetThisInvoice(prevProps, nextProps) {
  const nextFieldName = nextProps.fieldName;
  if (!nextFieldName) return false;
  const invoiceIndex = prevProps.invoiceItemIndex;
  return (
    nextFieldName.indexOf(`${invoiceIndex}`) === 0 ||
    nextFieldName.indexOf(`invoiceAmount-${invoiceIndex}`) === 0 ||
    nextFieldName.indexOf(`foreignCurrencyToUsdExchangeRate-${invoiceIndex}`) === 0 ||
    nextFieldName.indexOf(`totalCharges-${invoiceIndex}`) === 0 ||
    nextFieldName.indexOf(`totalEnteredValue-${invoiceIndex}`) === 0
  );
}

function currencyExchangeInfoChanged(prevInfo, nextInfo) {
  const prev = prevInfo || {};
  const next = nextInfo || {};
  return (
    prev.fromIsoCurrencyCode !== next.fromIsoCurrencyCode ||
    prev.exchangeRate !== next.exchangeRate ||
    prev.enteredManuallyByBroker !== next.enteredManuallyByBroker ||
    prev.exchangeDate !== next.exchangeDate
  );
}

export function shouldInvoiceLineItemUpdate(prevProps, nextProps, prevState, nextState) {
  if (window.slowstate) return true;

  if (nextProps.merchandiseLineItems !== prevProps.merchandiseLineItems) return true;
  if (nextProps.expandInvoiceItem !== prevProps.expandInvoiceItem) return true;
  if (nextProps.showLoader !== prevProps.showLoader) return true;
  if (nextProps.hasFetchedMetadata !== prevProps.hasFetchedMetadata) return true;
  if (nextProps.invoiceValidObjectsBl !== prevProps.invoiceValidObjectsBl) return true;
  if (nextProps.invoiceWarnings !== prevProps.invoiceWarnings) return true;
  if (nextProps.pscData !== prevProps.pscData) return true;
  if (nextProps.currentJobData !== prevProps.currentJobData) return true;
  if (nextProps.exportDateq !== prevProps.exportDateq) return true;
  if (nextProps.countryOfExport !== prevProps.countryOfExport) return true;
  if (nextProps.allCurrencyCodes !== prevProps.allCurrencyCodes) return true;
  if (nextProps.expandAll !== prevProps.expandAll) return true;
  if (nextProps.expandAllLines !== prevProps.expandAllLines) return true;
  if (nextProps.isPscMode !== prevProps.isPscMode) return true;
  if (nextProps.merchandiseItemCount !== prevProps.merchandiseItemCount) return true;

  if (INVOICE_LINE_SCALAR_PROPS.some((key) => nextProps[key] !== prevProps[key])) {
    return true;
  }

  if (currencyExchangeInfoChanged(prevProps.currencyExchangeInfo, nextProps.currencyExchangeInfo)) {
    return true;
  }

  const formValuesChanged = INVOICE_LINE_FORM_VALUE_KEYS.some(
    (key) => nextProps[key] !== prevProps[key]
  );
  if (formValuesChanged && formValuesTargetThisInvoice(prevProps, nextProps)) {
    return true;
  }

  if (!propsAreEqual_NoRerenderNeeded(prevState, nextState)) return true;

  return false;
}

export function shouldMerchandiseLineItemUpdate(prevProps, nextProps, prevState, nextState) {
  if (window.slowstate) return true;

  // Product History updates via prodHistoryFormData (mapStateToProps returns {})
  if (nextProps.prodHistoryFormData !== prevProps.prodHistoryFormData) return true;

  if (nextProps.thisMerchandiseItem !== prevProps.thisMerchandiseItem) return true;
  if (nextProps.merchandiseMetadata !== prevProps.merchandiseMetadata) return true;
  if (nextProps.importerAdditionalDeclarationDetails !== prevProps.importerAdditionalDeclarationDetails) return true;
  if (nextProps.merchandiseDuties !== prevProps.merchandiseDuties) return true;
  if (nextProps.allDuties !== prevProps.allDuties) return true;
  if (nextProps.pgaFlagInfos !== prevProps.pgaFlagInfos) return true;
  if (nextProps.lineValidObjectsBl !== prevProps.lineValidObjectsBl) return true;
  if (nextProps.pscData !== prevProps.pscData) return true;
  if (nextProps.EntryTypeInfo !== prevProps.EntryTypeInfo) return true;
  if (nextProps.expandAllLines !== prevProps.expandAllLines) return true;
  if (nextProps.expandAll !== prevProps.expandAll) return true;
  if (nextProps.formDisabled !== prevProps.formDisabled) return true;
  if (nextProps.allsequenceNumberSorted !== prevProps.allsequenceNumberSorted) return true;
  if (nextProps.availableProductClaimCode !== prevProps.availableProductClaimCode) return true;
  if (nextProps.adcvd !== prevProps.adcvd) return true;

  const formValuesChanged = MERCH_LINE_FORM_VALUE_KEYS.some(
    (key) => nextProps[key] !== prevProps[key]
  );
  if (formValuesChanged) {
    return formValuesTargetThisMerchandiseLine(prevProps, nextProps);
  }

  if (!propsAreEqual_NoRerenderNeeded(prevState, nextState)) return true;

  return false;
}

export function areMerchandiseLineStatePropsEqual(nextProps, prevProps) {
  if (nextProps.prodHistoryFormData !== prevProps.prodHistoryFormData) return false;
  if (nextProps.thisMerchandiseItem !== prevProps.thisMerchandiseItem) return false;
  if (nextProps.merchandiseMetadata !== prevProps.merchandiseMetadata) return false;
  if (nextProps.importerAdditionalDeclarationDetails !== prevProps.importerAdditionalDeclarationDetails) return false;
  if (nextProps.merchandiseDuties !== prevProps.merchandiseDuties) return false;
  if (nextProps.allDuties !== prevProps.allDuties) return false;
  if (nextProps.pgaFlagInfos !== prevProps.pgaFlagInfos) return false;
  if (nextProps.lineValidObjectsBl !== prevProps.lineValidObjectsBl) return false;
  if (nextProps.pscData !== prevProps.pscData) return false;
  if (nextProps.EntryTypeInfo !== prevProps.EntryTypeInfo) return false;
  if (nextProps.expandAllLines !== prevProps.expandAllLines) return false;
  if (nextProps.expandAll !== prevProps.expandAll) return false;
  if (nextProps.formDisabled !== prevProps.formDisabled) return false;
  if (nextProps.allsequenceNumberSorted !== prevProps.allsequenceNumberSorted) return false;
  if (nextProps.availableProductClaimCode !== prevProps.availableProductClaimCode) return false;
  if (nextProps.pscMerchandiseLineItems !== prevProps.pscMerchandiseLineItems) return false;
  if (nextProps.adcvd !== prevProps.adcvd) return false;

  const formValuesChanged = MERCH_LINE_FORM_VALUE_KEYS.some(
    (key) => nextProps[key] !== prevProps[key]
  );
  if (formValuesChanged) {
    return !formValuesTargetThisMerchandiseLine(prevProps, nextProps);
  }

  const skipKeys = new Set([
    ...MERCH_LINE_FORM_VALUE_KEYS,
    'thisMerchandiseItem',
    'merchandiseMetadata',
    'importerAdditionalDeclarationDetails',
    'merchandiseDuties',
    'allDuties',
    'pgaFlagInfos',
    'lineValidObjectsBl',
    'pscData',
    'EntryTypeInfo',
    'expandAllLines',
    'expandAll',
    'formDisabled',
    'allsequenceNumberSorted',
    'availableProductClaimCode',
    'pscMerchandiseLineItems',
  ]);

  const keys = Object.keys(nextProps);
  for (let i = 0; i < keys.length; i += 1) {
    const key = keys[i];
    if (skipKeys.has(key)) continue;
    if (nextProps[key] !== prevProps[key]) return false;
  }

  return true;
}

export const hasanyvaluesAdcvd =(mylocaladcvdval,adorcvd)=>{
  if(!mylocaladcvdval)return false;
  if(!mylocaladcvdval[adorcvd])return false;
  let hasvaluethisvar = (varxx)=>{
    return varxx && varxx != "0" && varxx != "0.00" && varxx != '_BLANK_'&& varxx != '-999'&& varxx != '_DELETE_';
  }
  return hasvaluethisvar(mylocaladcvdval[adorcvd].caseDepositRate)||
      hasvaluethisvar(mylocaladcvdval[adorcvd].caseNo) ||
      hasvaluethisvar(mylocaladcvdval[adorcvd].dutyAmount) ||
      hasvaluethisvar(mylocaladcvdval[adorcvd].caseRateCode) ||
      hasvaluethisvar(mylocaladcvdval[adorcvd].claimCode) ||
      hasvaluethisvar(mylocaladcvdval[adorcvd].specialQuantity) ||
      hasvaluethisvar(mylocaladcvdval[adorcvd].specialValue);

}

export const calculateLineItemWeightsBasedOnGrossWeightAndTotalValueAsync = async (
  grossWeight,
  grossWeightUnit,
  invoices
) => {
    
  const getSumOfDuties = (lineitems) => {
    let rettotalValue = 0;
    for (let _item of lineitems) {
      let appendvalue = _item.isCommodityDuty == 1;
      if (appendvalue) {
        // Use adjustedValue if >= 0.01, otherwise fallback to enteredValue
        rettotalValue += parseFloat(_item.adjustedValue) >= 0.01 ?
          parseFloat(_item.adjustedValue) : parseFloat(_item.enteredValue)
      }
    }
    return rettotalValue;

  };

  let totalValue = 0;
  (invoices || []).forEach(invoiceItem => {
    invoiceItem.merchandiseLineItems.forEach(lineItem => {
      if (lineItem.articleHeader !== 'V') {
        totalValue += getSumOfDuties(lineItem.merchandiseDuties)
      }
    })
  })

  const savePromises = []

  if (parseFloat(totalValue) !== 0 && invoices.length >= 1) {
    // Distribute weight proportionally based on value
    let factor = parseFloat(grossWeight) / parseFloat(totalValue)
    invoices.forEach(invoiceItem =>{
      let merchandiseItemList = [];
      let oldWeights = [];
      invoiceItem.merchandiseLineItems.forEach(lineItem => {
        oldWeights.push(parseInt(lineItem.grossWeight.weight));
        if(lineItem.articleHeader!=='V' || true){
          let enteredVal = getSumOfDuties(lineItem.merchandiseDuties)
          const kginalb = 0.45359237; // KG to LB conversion factor
           let weight = parseFloat(
              parseFloat(enteredVal) * factor
            )
            if (
              grossWeightUnit &&
              grossWeightUnit.toUpperCase() === 'KG' &&
              lineItem.grossWeight.weightUnits === 'LB'
            ) {
              lineItem.grossWeight.weight = (weight / kginalb).toFixed(2)
            } else if (
              grossWeightUnit &&
              grossWeightUnit.toUpperCase() === 'LB' &&
              lineItem.grossWeight.weightUnits === 'KG'
            ) {
              lineItem.grossWeight.weight = (weight * kginalb).toFixed(2)
            } else {
              lineItem.grossWeight.weight = (weight).toFixed(2)
              if (grossWeightUnit && grossWeightUnit.toUpperCase() === 'LB') {
                lineItem.grossWeight.weightUnits = 'LB'
              }
              if (grossWeightUnit && grossWeightUnit.toUpperCase() === 'KG') {
                lineItem.grossWeight.weightUnits = 'KG'
              }
            }
            // Minimum weight of 1.00
            lineItem.grossWeight.weight = Math.round(Math.max(lineItem.grossWeight.weight,1.00)).toFixed(2)
                  
            merchandiseItemList.push({
              merchandiseId     : lineItem.merchandiseId,
              articleSetId      : lineItem.articleSetId,
              grossWeight : lineItem.grossWeight
            })
    
          }     
      })
    if(!isEqual(oldWeights,merchandiseItemList.map(aaa=>parseInt(aaa?.grossWeight?.weight)))){
      savePromises.push(saveDescriptionOfMerchandiseDutyItemArray(invoiceItem.invoiceId, merchandiseItemList))
    }
    })
  }
  await Promise.all(savePromises)
  return invoices
}

export const calculateLineItemWeightsBasedOnGrossWeightAndTotalValue =  (
  grossWeight,
  grossWeightUnit,
  invoices
) => {
    
  const getSumOfDuties = (lineitems) => {
    let rettotalValue = 0;
    for (let _item of lineitems) {
      let appendvalue = _item.isCommodityDuty == 1;
      if (appendvalue) {
        // Use adjustedValue if >= 0.01, otherwise fallback to enteredValue
        rettotalValue += parseFloat(_item.adjustedValue) >= 0.01 ?
          parseFloat(_item.adjustedValue) : parseFloat(_item.enteredValue)
      }
    }
    return rettotalValue;

  };

  let totalValue = 0;
  (invoices || []).forEach(invoiceItem => {
    invoiceItem.merchandiseLineItems.forEach(lineItem => {
      if (lineItem.articleHeader !== 'V') {
        totalValue += getSumOfDuties(lineItem.merchandiseDuties)
      }
    })
  })

  if (parseFloat(totalValue) !== 0 && invoices.length >= 1) {
    // Distribute weight proportionally based on value
    let factor = parseFloat(grossWeight) / parseFloat(totalValue)
    invoices.forEach(invoiceItem =>{
      let merchandiseItemList = [];
      let oldWeights = [];
      invoiceItem.merchandiseLineItems.forEach(lineItem => {
        oldWeights.push(parseInt(lineItem.grossWeight.weight));
        if(lineItem.articleHeader!=='V' || true){
          let enteredVal = getSumOfDuties(lineItem.merchandiseDuties)
          const kginalb = 0.45359237; // KG to LB conversion factor
           let weight = parseFloat(
              parseFloat(enteredVal) * factor
            )
            if (
              grossWeightUnit &&
              grossWeightUnit.toUpperCase() === 'KG' &&
              lineItem.grossWeight.weightUnits === 'LB'
            ) {
              lineItem.grossWeight.weight = (weight / kginalb).toFixed(2)
            } else if (
              grossWeightUnit &&
              grossWeightUnit.toUpperCase() === 'LB' &&
              lineItem.grossWeight.weightUnits === 'KG'
            ) {
              lineItem.grossWeight.weight = (weight * kginalb).toFixed(2)
            } else {
              lineItem.grossWeight.weight = (weight).toFixed(2)
              if (grossWeightUnit && grossWeightUnit.toUpperCase() === 'LB') {
                lineItem.grossWeight.weightUnits = 'LB'
              }
              if (grossWeightUnit && grossWeightUnit.toUpperCase() === 'KG') {
                lineItem.grossWeight.weightUnits = 'KG'
              }
            }
            // Minimum weight of 1.00
            lineItem.grossWeight.weight = Math.round(Math.max(lineItem.grossWeight.weight,1.00)).toFixed(2)
                  
            merchandiseItemList.push({
              merchandiseId     : lineItem.merchandiseId,
              articleSetId      : lineItem.articleSetId,
              grossWeight : lineItem.grossWeight
            })
    
          }     
      })
    if(!isEqual(oldWeights,merchandiseItemList.map(aaa=>parseInt(aaa?.grossWeight?.weight)))){
      saveDescriptionOfMerchandiseDutyItemArray(invoiceItem.invoiceId, merchandiseItemList)
    }
    })
  }

  return invoices
}

export const updateDutyAndFee = (newLineItems, htsList) => {
  newLineItems.forEach(lineItem => {
    let merchandiseId = lineItem.merchandiseId
    lineItem.merchandiseDuties.forEach(dutyItem => {
      if (dutyItem.isCommodityDuty === 1) {
        dutyItem.duty = parseFloat(htsList[dutyItem.htsus].duty).toFixed(2)
        dutyItem.mpf.fee = parseFloat(htsList[dutyItem.htsus].mpfVal).toFixed(2)
        dutyItem.hmf.fee = parseFloat(htsList[dutyItem.htsus].hmfVal).toFixed(2)
        saveDutyAndFeeFromHts(
          merchandiseId,
          dutyItem.merchandiseDutyId,
          dutyItem.duty,
          dutyItem.mpf.fee,
          dutyItem.hmf.fee,
          dutyItem.isCommodityDuty
        )
      } else if (dutyItem.isCommodityDuty !== 1) {
        dutyItem.duty = parseFloat(htsList[dutyItem.hts].duty).toFixed(2)
        saveDutyFromHts(
          merchandiseId,
          dutyItem.merchandiseDutyId,
          dutyItem.duty,
          dutyItem.isCommodityDuty
        )
      }
    })
  })
  return newLineItems
}

export const inCompletedPgaStatus =  (merchandiseData) => {
  let inCompletedPga = [];

  const dataArray = merchandiseData || [];
  for(let invoiceIndex=0; invoiceIndex < dataArray.length; invoiceIndex++){
    const invoiceItem = dataArray[invoiceIndex];
    if(!invoiceItem?.merchandiseLineItems)continue;
    
    const invoiceNum = (invoiceIndex + 1).toString().padStart(3, '0');
    const invoicePrefix = `(Invoice ${invoiceNum})`;
    const lineItems = invoiceItem.merchandiseLineItems;
    
    for(let merchandiseIndexi=0; merchandiseIndexi < lineItems.length; merchandiseIndexi++){
      const lineItem = lineItems[merchandiseIndexi];
      const merchNum = (merchandiseIndexi + 1).toString().padStart(3, '0');
      const locationString = `${invoicePrefix} (Merchandise ${merchNum}):`;
      const merchandiseId = lineItem.merchandiseId;
      
      const pgaFlagInfos = lineItem.pgaFlagInfos || [];
      if(!pgaFlagInfos.length && !lineItem.merchandiseDuties?.length)continue;
      
      // Use Set for O(1) lookups instead of array O(n) operations
      const selectedPgaSet = new Set(pgaFlagInfos.map(a=>a.formType||a.pgaType));
      const hasFDADisclaimPga = selectedPgaSet.has("DISCLAIM_PGA");
      
      //detect required flags that aren't being addressed
      const merchandiseDuty = lineItem.merchandiseDuties?.find((_item) => {
        return (_item.isCommodityDuty === 1);
      });
      const tarriffPgaDetails = get(merchandiseDuty, 'hsDataDtl.pgaMetadata.tarriffPgaDetails', []);
      
      // Expand selected PGAs to include all FDA types if disclaim is present
      const expandedSelectedPgas = hasFDADisclaimPga ? new Set([...selectedPgaSet, ...fdaDisclaimList]) : selectedPgaSet;
      
      // Check required PGAs
      if(tarriffPgaDetails.length > 0){
        for (let oneRequiredPGA of tarriffPgaDetails) {
          if (isCpscCp2Tariff(oneRequiredPGA)) continue;
          const programFormTypes = oneRequiredPGA?.programDetails?.map(a => a.formType) || [];
          // Use Set intersection for O(n) with O(1) lookups instead of O(n×m)
          const hasThisPga = programFormTypes.filter(pga => expandedSelectedPgas.has(pga));
          if (!hasThisPga || !hasThisPga.length) {
            inCompletedPga.push({
              "merchandiseId": merchandiseId,
              "fieldmessage": `${locationString} PGA program ${oneRequiredPGA?.programName}: Select a program`, "fieldmessagetype": "FAIL"
            })
          }
        }
      }

      //detect incomplete flags
      if(pgaFlagInfos.length > 0){
        for(let oneFlag of pgaFlagInfos){
          if(oneFlag.isOnlyForDisclaim)continue;
          // FDA sub-types cannot be selected if DISCLAIM_PGA is present
          if(hasFDADisclaimPga && oneFlag.formType?.startsWith("FDA_")){
            inCompletedPga.push({"merchandiseId": merchandiseId, "fieldmessage": `${locationString} #PGA : ${oneFlag.formType} is not allowed if there's a FDA DISCLAIM present`, "fieldmessagetype": "FAIL"});
            continue;
          }
          if(oneFlag.formType == "DISCLAIM_PGA")continue;//disclaim pga requires no info
          if (shouldSkipIncompleteCpscFlag(oneFlag, tarriffPgaDetails)) continue;
          if(oneFlag.pgaFlagStatus != '1'){
            inCompletedPga.push({"merchandiseId": merchandiseId, "fieldmessage": `${locationString} #PGA : ${oneFlag.formType} is not completed`, "fieldmessagetype": "FAIL"})
          }
        }
      }
    }
  }
  return inCompletedPga;
}

// UI action handlers - separated from validation logic (exported for use in reducer)
export const handlePriorityErrorUI = (firstPriorityError) => {
  setTimeout(() => {
    const nameofWarningTabOnUI = "nameOfWarningTab" + firstPriorityError.tab;
    const warningTabElement = document.getElementsByClassName(nameofWarningTabOnUI)[0];
    if(warningTabElement){
      warningTabElement.click();
    }
  }, 20);
  
  setTimeout(() => {
    const warningBoxAboveFormcontentarea = document.getElementsByClassName("warningBoxAboveFormcontentarea")[0];
    if(warningBoxAboveFormcontentarea){
      const hideerrorbutton = document.getElementsByClassName("hideError")[0];
      if(hideerrorbutton && warningBoxAboveFormcontentarea.children[0]){
        warningBoxAboveFormcontentarea.children[0].click();
      }
      warningBoxAboveFormcontentarea.classList.add("flashfxx");
      setTimeout(() => {
        warningBoxAboveFormcontentarea.classList.remove("flashfxx");
      }, 650);
    }
  }, 60);
};

export const showPopupWarnings = (popupwarns) => {
  let htmtttmtml = <div style={{maxHeight:'20vh',overflowY:'scroll',border:'1px dashed gray'}}>{popupwarns.map((onewarn,iii)=>{
    return <div key={onewarn.msg+onewarn.location+" htgf"+iii}><b>{onewarn.location}</b> {onewarn.msg}</div>
  })

  }
  </div>;
  confirmAlert({
    closeOnClickOutside: false,
    overlayClassName: 'bigConfirmAlert',
    title: "These warnings are not critical. Do you want to ignore them?",
    message: htmtttmtml,
    buttons: [
      {
        label: "Ignore",
        onClick: () => {
          window.ignorewarningpopup = true
          const finalReviewButton = document.getElementById("FINAL_REVIEW") || document.getElementById("FINAL_REVIEW_STC")
          if (finalReviewButton) {
            finalReviewButton.click()
          }
        },
      },
      {
        label: "Back",
        onClick: () => {
        }
      }
    ],
  });
};

export const showEntryTypeConfirmation = (maxShipmentValue) => {
  confirmAlert({
    closeOnClickOutside: false,
    title: "Confirmation!",
    message: `The total shipment value is less than or equal to $${maxShipmentValue}, so entry type can be selected as "11 - Informal" which will reduce the shipment MPF. Do you want to go back and change the entry type?`,
    buttons: [
      {
        label: "YES",
        onClick: () => {
          document.getElementsByClassName("bolAwbInfo")[0].click();
          window.ignore = false;
        },
      },
      {
        label: "NO",
        onClick: () => {
          window.ignore = true
          // Try to find FINAL REVIEW button - could be entry summary (FINAL_REVIEW) or STC (FINAL_REVIEW_STC)
          const finalReviewButton = document.getElementById("FINAL_REVIEW") || document.getElementById("FINAL_REVIEW_STC")
          if (finalReviewButton) {
            finalReviewButton.click()
          }
        }
      }
    ],
  });
};

export const validationForRequiredFields = (completeStore, updateType) => {
  let error = []
  const merchandises = completeStore.DescriptionOfMerchandise;
  const merchandiseData = merchandises.entrySummaryInvoices;
  const entryType = completeStore.EntryTypeInfo;
  const transportation = completeStore.TransportationInfo;
  const declaration = completeStore.DeclarationSection;
  const fieldValidations = completeStore.FieldValidation;
  const BOLInfo = completeStore.BOLInfo;
    let totalValue = merchandises.totalValue;
  let isCwCompleted = true;
  
  // Check if this is STC/DHL flow
  const isStcDhlFlow = isStcFlow();
  
  if(fieldValidations?.fields?.length){
    for(const item of fieldValidations.fields){
      if(!(item.overrideCodeUsed || item.valueChanged === 1) && item.isWarningResolved == 2 ){
        isCwCompleted = false;
        break;
      }
    }
  }

  const warnings = fieldValidations?.warnings || [];
  let priorityErrors = warnings.filter(a=>a.priorityErrorFinalReview);
  let uiActions = [];
  if(priorityErrors.length){
    const firstPriorityError = priorityErrors[0];
    uiActions.push({ type: 'handlePriorityError', data: firstPriorityError });
    error.push({"fieldmessage":`Complete required PGAs`, "fieldmessagetype": "NOSHOW"})
  }
  let popupwarns = warnings.filter(a=>a.popupWarnFinalReview);
  if(!window.ignorewarningpopup && popupwarns && popupwarns.length){
    uiActions.push({ type: 'showPopupWarnings', data: popupwarns });
    error.push({"fieldmessage":`${popupwarns[0].location} ${popupwarns[0].msg}`, "fieldmessagetype": "FAIL"})
  }
  
  // Calculate PGA validation skip condition early
  const psc = completeStore.PSC || {};
  const pscShipmentId = psc.pscShipmentId;
  const requiresIgnoreValidation = updateType === 'cargoReleaseUpdate' || updateType === 'entryUpdate';
  const ignorevalidation = requiresIgnoreValidation || pscShipmentId || isWarehouseEntry(entryType);
  
  let isEntirelyUSandChapter98 = true;
  for(let invoiceIndex = 0; invoiceIndex < (merchandiseData||[]).length; invoiceIndex++){
    const invoiceItem = merchandiseData[invoiceIndex];
    const invoiceNum = invoiceIndex + 1;
    const invoiceNumStr = invoiceNum.toString().padStart(3, '0');
    const invoicePrefix = `(Invoice ${invoiceNumStr})`;
    
    if(!invoiceItem.merchandiseLineItems || invoiceItem.merchandiseLineItems.length == 0){
      error.push({"fieldmessage":`Invoice ${invoiceNum}: No merchandise line items`, "fieldmessagetype": "FAIL"})
      continue;
    }
    
    for(let lineIndex = 0; lineIndex < invoiceItem.merchandiseLineItems.length; lineIndex++){
      const lineItem = invoiceItem.merchandiseLineItems[lineIndex];
      const lineNumStr = (lineIndex + 1).toString().padStart(3, '0');
      const locationString = `${invoicePrefix} (Merchandise ${lineNumStr}):`;
      const merchandiseId = lineItem.merchandiseId;
      
      const merchandiseDuties = lineItem.merchandiseDuties || [];
      
      // Check Chapter 98 classification (only if still possible)
      if(isEntirelyUSandChapter98){
        if(lineItem.countryOfOrigin != "US"){
          isEntirelyUSandChapter98 = false;
        }
      }
      
      if(lineItem.grossWeight){
        if(!lineItem.grossWeight.weightUnits || lineItem.grossWeight.weightUnits === "_BLANK_" || !lineItem.grossWeight.weight || lineItem.grossWeight.weight == 0){
          error.push({"fieldmessage":`Line Item weight is required - Invoice: #${invoiceNumStr} Line: #${lineNumStr}`, "fieldmessagetype": "FAIL"})
        }
      }
      
      // Combined duty loop: Chapter 98 check + validation checks
      // Optimized: Single loop instead of two separate loops
      if(merchandiseDuties.length > 0){
        for(let dutyIndex = 0; dutyIndex < merchandiseDuties.length; dutyIndex++){
          const dutyItem = merchandiseDuties[dutyIndex];
          
          // Chapter 98 check: Once flag is false, skip check for remaining duties
          if(isEntirelyUSandChapter98 && lineItem.countryOfOrigin === "US"){
            if(!(dutyItem.htsus || "").startsWith("98")){
              isEntirelyUSandChapter98 = false;
              // Note: Continue loop to validate all duties (can't break early)
            }
          }
          
          // Validation checks: Must check all duties to collect all errors
          if(dutyItem.isValidHts === false){
            error.push({"fieldmessage":`"${dutyItem.htsus}" is not a valid HTS - Invoice: #${invoiceNumStr} Line: #${lineNumStr}`, "fieldmessagetype": "FAIL"})
          }
          if(dutyItem.additionalQuantity){
            const additionalUom = String(dutyItem.additionalQuantity.units || "").toUpperCase();
            // CBP QTY 2: JWL UOM allows quantity to be 0 or blank
            if(dutyItem.additionalQuantity.units && dutyItem.additionalQuantity.units !== "_BLANK_" && additionalUom !== "JWL" && (!dutyItem.additionalQuantity.quantity || dutyItem.additionalQuantity.quantity == 0)){
              error.push({"fieldmessage":`Additional quantity is required when the unit of measurement is present - Invoice: #${invoiceNumStr} Line: #${lineNumStr}`, "fieldmessagetype": "FAIL"})
            }
          }
        }
      }
      
      // PGA validation (integrated into main loop to avoid redundant iteration)
      // Skip PGA validation for STC/DHL flow
      if(!ignorevalidation && !isStcDhlFlow){
        const pgaFlagInfos = lineItem.pgaFlagInfos || [];
        if(pgaFlagInfos.length > 0 || merchandiseDuties.length > 0){
          // Use Set for O(1) lookups instead of array O(n) operations
          const selectedPgaSet = new Set(pgaFlagInfos.map(a=>a.formType||a.pgaType));
          const hasFDADisclaimPga = selectedPgaSet.has("DISCLAIM_PGA");
          
          //detect required flags that aren't being addressed
          const merchandiseDuty = merchandiseDuties.find((_item) => {
            return (_item.isCommodityDuty === 1);
          });
          const tarriffPgaDetails = get(merchandiseDuty, 'hsDataDtl.pgaMetadata.tarriffPgaDetails', []);
          
          // Expand selected PGAs to include all FDA types if disclaim is present
          const expandedSelectedPgas = hasFDADisclaimPga ? new Set([...selectedPgaSet, ...fdaDisclaimList]) : selectedPgaSet;
          
          // Check required PGAs
          if(tarriffPgaDetails.length > 0){
            for (let oneRequiredPGA of tarriffPgaDetails) {
              if (isCpscCp2Tariff(oneRequiredPGA)) continue;
              const programFormTypes = oneRequiredPGA?.programDetails?.map(a => a.formType) || [];
              const programFormTypesSet = new Set(programFormTypes);
              // Use Set intersection for O(n) with O(1) lookups instead of O(n×m)
              const hasThisPga = programFormTypes.filter(pga => expandedSelectedPgas.has(pga));
              if (!hasThisPga || !hasThisPga.length) {
                error.push({
                  "merchandiseId": merchandiseId,
                  "fieldmessage": `${locationString} PGA program ${oneRequiredPGA?.programName}: Select a program`, "fieldmessagetype": "FAIL"
                })
              }
            }
          }

          //detect incomplete flags
          if(pgaFlagInfos.length > 0){
            for(let oneFlag of pgaFlagInfos){
              if(oneFlag.isOnlyForDisclaim)continue;
              // FDA sub-types cannot be selected if DISCLAIM_PGA is present
              if(hasFDADisclaimPga && oneFlag.formType?.startsWith("FDA_")){
                error.push({"merchandiseId": merchandiseId, "fieldmessage": `${locationString} #PGA : ${oneFlag.formType} is not allowed if there's a FDA DISCLAIM present`, "fieldmessagetype": "FAIL"});
                continue;
              }
              if(oneFlag.formType == "DISCLAIM_PGA")continue;//disclaim pga requires no info
              if (shouldSkipIncompleteCpscFlag(oneFlag, tarriffPgaDetails)) continue;
              if(oneFlag.pgaFlagStatus != '1'){
                error.push({"merchandiseId": merchandiseId, "fieldmessage": `${locationString} #PGA : ${oneFlag.formType} is not completed`, "fieldmessagetype": "FAIL"})
              }
            }
          }
        }
      }
    }
  }
  
  // Max value for informal entry: $10K (US/Chapter 98) or $2.5K (others)
  let maxShipmentValue = isEntirelyUSandChapter98?10000:2500;
  if(!isStcDhlFlow && !pscShipmentId && !window.ignore && totalValue <= maxShipmentValue && entryType.entryType!= 11){
    uiActions.push({ type: 'showEntryTypeConfirmation', data: maxShipmentValue });
    error.push({"fieldmessage":`The total shipment value is less than or equal to $${maxShipmentValue}, so entry type can be selected as "11 - Informal" which will reduce the shipment MPF. Do you want to go back and change the entry type?" `, "fieldmessagetype": "NOSHOW"})
  }
  if(totalValue > maxShipmentValue && entryType.entryType == 11){
    error.push({"fieldmessage":`The total shipment value exceeds $${maxShipmentValue}, so the "11 - Informal" entry type is not permitted. Please select an appropriate entry type.`, "fieldmessagetype": "FAIL"})
  }
  if(!isCwCompleted && (updateType === "combined" || updateType === "entryUpdate")){
    error.push({"fieldmessage":`All the census warnings are not marked resolved. If a census warning override is Filed, wait for it to be in Accepted or Rejected state.`, "fieldmessagetype": "FAIL"})
  }
  // Skip Port of Unlading validation for STC/DHL flow
  if(!isStcDhlFlow && (!transportation.USportOfUnladingCode || (transportation.USportOfUnladingCode && !transportation.USportOfUnladingCode.id))){
      error.push({"fieldmessage":"Entry Type: US Port of unlading is missing", "fieldmessagetype": "FAIL"})
  }

  if (!shouldSkipItDateItNumberValidation(entryType?.entryType)) {
    let isEngineView = window.GLOBAL_MAIN_TOKEN_KXBROKERTOKEN == 'kxEngineBrokerToken';
    if (!isEngineView) {
      const itDateEpochs = BOLInfo.itDate?.epochs;
      const hasValidItDate = itDateEpochs && itDateEpochs !== -999;
      const itNumber = BOLInfo.itNumber;
      const hasItNumber = itNumber && itNumber.length && itNumber !== "_BLANK_";
      
      if (hasItNumber) {
        if (!itDateEpochs || itDateEpochs == "-999") {
          error.push({ "fieldmessage": "I.T.DATE is required with I.T.NUMBER", "fieldmessagetype": "FAIL" })
        }
      }

      if (hasValidItDate) {
        if (!hasItNumber) {
          error.push({
            "fieldmessage": "I.T.NUMBER is required with I.T.DATE", "fieldmessagetype": "FAIL"
          })
        } else if (!IT_NUMBER_REGEX.test(itNumber)) {
          error.push({
            "fieldmessage": "I.T.NUMBER is alphanumeric", "fieldmessagetype": "FAIL"
          })
        }
      }

      if (hasValidItDate && entryType.summaryDate?.epochs) {
        // 31556926000 ms = 12 months
        const diff = Math.abs(itDateEpochs - entryType.summaryDate.epochs)
        if (diff > 31556926000) {
          error.push({
            "fieldmessage": 'IT Date must be within 12 months of entry date', "fieldmessagetype": "FAIL"
          })
        }
      }
    } else if (isEngineView) {
      const engineRecord = BOLInfo?.engineBolInfo?.engineBolRecord;
      const itNumber = engineRecord?.find((rec)=>rec?.itNumber)?.itNumber;

      const hasItNumber = itNumber && itNumber !== "_BLANK_";
      const hasItDate = BOLInfo?.itDate?.epochs && BOLInfo?.itDate.epochs !== -999;
      
      if (hasItNumber && !hasItDate) {
        error.push({
          fieldmessage: "I.T.DATE is required with I.T.NUMBER",
          fieldmessagetype: "FAIL"
        });
      }
    
      if (hasItDate && !hasItNumber) {
        error.push({
          fieldmessage: "I.T.NUMBER is required with I.T.DATE",
          fieldmessagetype: "FAIL"
        });
      }
    }
  }

  
  // Skip Port of Entry validation for STC/DHL flow (but keep Entry Date validation)
  if(!isStcDhlFlow && (!entryType.portCode || !entryType.portCode.id)){
      error.push({"fieldmessage":"Entry type PortCode is missing", "fieldmessagetype": "FAIL"})
  }
  // Skip Sign tab validations for STC/DHL and engine shipment flows
  if(!isStcDhlFlow && !isShipmentFromEngine() && !((declaration.trueInvoiceFlag == 1 || declaration.bestInvoiceFlag == 1) && (declaration.actualOwnerFlag == 1 || declaration.purchaserFlag == 1))){
    error.push({"fieldmessage":"Sign is not completed", "fieldmessagetype": "FAIL"})
  }
  if(pscShipmentId && (!psc.headerCodes && !psc.lineCodes)){
    error.push({"fieldmessage":"PSC reason(s) are missing", "fieldmessagetype": "FAIL"})
  }
  if(pscShipmentId && !psc.pscFileExplanation){
    error.push({"fieldmessage":"PSC explanation is missing", "fieldmessagetype": "FAIL"})
  }
  if(pscShipmentId && !psc.accelaratedLiquidation){
    error.push({"fieldmessage":"PSC liquidation option is not selected!", "fieldmessagetype": "FAIL"})
  }
  if(pscShipmentId && psc.confirmPSC!=1){
    error.push({"fieldmessage":"Please Confirm the Post Summary Correction!", "fieldmessagetype": "FAIL"})
  }
  return { errors: error, uiActions: uiActions };
}
